module.exports = __webpack_public_path__ + "img/thumbnail_WesternDiamondBackRattlesnake_u_albino.f299b6ca.png";